(function LivePlannerParticipants($, Adzuki)
{
	"use strict";

	var LivePlannerParticipants = {};
	var form_id                 = null;
	var form_name               = null;
	var max_attendees           = 24;

	LivePlannerParticipants.init = function init(form_name_key)
	{
		form_name = 'form_component_data[' + form_name_key + ']';
		form_id   = form_name_key.toLowerCase();

		// show/hide radio to ask if the client wants to add other participants
		$('.group-session-field').on('change', function _onChange(e) {
			var group_session = parseInt($(this).val());

			if (group_session) {
				$('.group-attendees').removeClass('hidden');
				return;
			}

			$('.group-attendees').addClass('hidden');

			// hide the fields to add attendees
			$('#' + form_id + '-group_session_attendees-0')
				.prop('checked', true)
				.attr('checked', 'checked')
				.parent().addClass('active');

			$('#' + form_id + '-group_session_attendees-1')
				.prop('checked', false)
				.removeAttr('checked')
				.parent().removeClass('active focus');

			_removeParticipantFields();
		});

		// show/hide field to enter/remove participants
		$('.group-session-attendees-field').on('change', function _onChange(e) {
			var add_more = parseInt($(this).val());

			if (add_more) {
				$('.group-add-participant').removeClass('hidden');
				$('.add-participant-row').removeClass('hidden');
				return;
			}

			_removeParticipantFields();
		});

		// click button to add another participant
		$('.add-participant').on('click', function _addParticipant(e) {
			var next_index       = $('.group-add-participant').length;
			var $new_participant = null;

			e.preventDefault();

			if (next_index >= max_attendees) {
				Adzuki.StatusMessage('error', 'You have reached the maximum number of attendees to add to your consultation. To add more attendees, please reach out to your travel advisor.');
				return;
			}

			$new_participant = $('.group-add-participant').first().clone();
			$new_participant.insertBefore('.add-participant-row');

			_updateParticipantIndex($new_participant, next_index, true);
			_addClickHandlerToRemoveParticipants();
		});
	};

	function _addClickHandlerToRemoveParticipants()
	{
		$('.remove-participant').off().on('click', function _addParticipant(e) {
			var $participant = $(this).parents('.group-add-participant');

			e.preventDefault();

			// this is the first participant, he cannot be removed
			if ($participant.data('index') === 0) {
				return;
			}

			$participant.remove();

			// update index on existing participants
			$('.group-add-participant').each(function _eachParticipant(i, elem) {
				var $cur_participant = $(elem);

				_updateParticipantIndex($cur_participant, i, false);
			});
		});
	}

	function _removeParticipantFields()
	{
		// remove all but the first participant and clear it's fields
		$('.group-add-participant').each(function _eachParticipant(i, elem) {
			var $participant = $(this);
			
			if (i === 0) {
				_updateParticipantIndex($participant, i, true);
				return true; // continue
			}

			$participant.find('.remove-participant').trigger('click');
		});

		$('.group-add-participant').addClass('hidden');
		$('.add-participant-row').addClass('hidden');
	}

	function _updateParticipantIndex($participant, index, reset_fields)
	{
		$participant.attr('data-index', index);
		$participant.data('index', index);
		$participant.find('.participant-num').first().text(index + 1);

		// display/hide button to remove it
		if ($participant.data('index') === 0) {
			$participant.find('.remove-participant').first().addClass('hidden');
		} else {
			$participant.find('.remove-participant').first().removeClass('hidden');
		}

		// update first name field
		$participant.find('.first-name-label').first()
		.attr('for', form_id + 'additional-participants-' + index + '-first_name');

		$participant.find('.first-name-field').first()
		.attr('id', form_id + 'additional-participants-' + index + '-first_name')
		.attr('name', form_name + '[additional_participants][' + index + '][first_name]');

		// update last name field
		$participant.find('.last-name-label').first()
		.attr('for', form_id + 'additional-participants-' + index + '-last_name');

		$participant.find('.last-name-field').first()
		.attr('id', form_id + 'additional-participants-' + index + '-last_name')
		.attr('name', form_name + '[additional_participants][' + index + '][last_name]');

		// update email field
		$participant.find('.email-label').first()
		.attr('for', form_id + 'additional-participants-' + index + '-email');

		$participant.find('.email-field').first()
		.attr('id', form_id + 'additional-participants-' + index + '-email')
		.attr('name', form_name + '[additional_participants][' + index + '][email]');

		// update travel deal optin field
		$participant.find('.optin-label').first()
		.attr('for', form_id + 'additional-participants-' + index + '-optin_weekly');

		$participant.find('.optin-field').first()
		.attr('id', form_id + 'additional-participants-' + index + '-optin_weekly')
		.attr('name', form_name + '[additional_participants][' + index + '][optin_weekly]')
		.prev().attr('name', form_name + '[additional_participants][' + index + '][optin_weekly]');

		if (reset_fields) {
			$participant.find('.first-name-field').first().val('');
			$participant.find('.last-name-field').first().val('');
			$participant.find('.email-field').first().val('');
			$participant.find('.optin-field').first()
			.prop('checked', false)
			.prev().val('0');
		}
	}

	Adzuki.LivePlannerParticipants = LivePlannerParticipants;
}(jQuery, window.Adzuki || {}));
